import { UserRoles } from '@/enums';
import { Dispatches } from '@/modules/dispatches/types';
import { all_roles } from '@/utils';

const access_roles = {
  [Dispatches.Pages.DISPATCHES]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
  ],
  [Dispatches.Pages.DISPATCH_DETAIL]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
  ],
  [Dispatches.Pages.DISPATCH_CORRECTIVE]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
  ],
};

export default access_roles;
